/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { CreateClassGroupReq } from '../_model/createClassGroupReq';
import type { CreateClassMaterialReq } from '../_model/createClassMaterialReq';
import type { GetAllClassroomsParams } from '../_model/getAllClassroomsParams';
import type { GetClassMemberQuizsetStatsParams } from '../_model/getClassMemberQuizsetStatsParams';
import type { GetClassMembersParams } from '../_model/getClassMembersParams';
import type { GetClassroomMemberStatsParams } from '../_model/getClassroomMemberStatsParams';
import type { GetJoinedClassroomsParams } from '../_model/getJoinedClassroomsParams';
import type { GetMyClassGroupsLinkedToContentParams } from '../_model/getMyClassGroupsLinkedToContentParams';
import type { GetMyClassGroupsParams } from '../_model/getMyClassGroupsParams';
import type { GetOwnedClassroomsParams } from '../_model/getOwnedClassroomsParams';
import type { LinkContentReq } from '../_model/linkContentReq';
import type { QuizsetSearchReq } from '../_model/quizsetSearchReq';
import type { SearchResponseListSearchQuizsetRes } from '../_model/searchResponseListSearchQuizsetRes';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyClassGroupDetailRes } from '../_model/successBodyClassGroupDetailRes';
import type { SuccessBodyClassGroupRes } from '../_model/successBodyClassGroupRes';
import type { SuccessBodyClassLinkRes } from '../_model/successBodyClassLinkRes';
import type { SuccessBodyClassMaterialFileUploadRes } from '../_model/successBodyClassMaterialFileUploadRes';
import type { SuccessBodyClassMaterialRes } from '../_model/successBodyClassMaterialRes';
import type { SuccessBodyClassMemberRes } from '../_model/successBodyClassMemberRes';
import type { SuccessBodyClassroomMemberStatsRes } from '../_model/successBodyClassroomMemberStatsRes';
import type { SuccessBodyClassroomRoleRes } from '../_model/successBodyClassroomRoleRes';
import type { SuccessBodyListClassGroupRes } from '../_model/successBodyListClassGroupRes';
import type { SuccessBodyListClassLinkRes } from '../_model/successBodyListClassLinkRes';
import type { SuccessBodyListClassMaterialRes } from '../_model/successBodyListClassMaterialRes';
import type { SuccessBodyListClassroomDashboardRes } from '../_model/successBodyListClassroomDashboardRes';
import type { SuccessBodyMemberListRes } from '../_model/successBodyMemberListRes';
import type { SuccessBodyQuizsetStatsPlayerDetailResponse } from '../_model/successBodyQuizsetStatsPlayerDetailResponse';
import type { SuccessBodyUpdateMemberNamesRes } from '../_model/successBodyUpdateMemberNamesRes';
import type { UpdateClassGroupReq } from '../_model/updateClassGroupReq';
import type { UpdateClassLinkReq } from '../_model/updateClassLinkReq';
import type { UpdateClassMaterialReq } from '../_model/updateClassMaterialReq';
import type { UpdateMemberNamesReq } from '../_model/updateMemberNamesReq';
import type { UpdateMemberReq } from '../_model/updateMemberReq';
import type { UploadMaterialFileBody } from '../_model/uploadMaterialFileBody';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getMyClassGroups = (
  params?: GetMyClassGroupsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassGroupRes>(
    { url: `/classrooms`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyClassGroupsQueryKey = (
  params?: GetMyClassGroupsParams,
) => {
  return [`/classrooms`, ...(params ? [params] : [])] as const;
};

export const getGetMyClassGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassGroupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassGroups>>
  > = ({ signal }) => getMyClassGroups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyClassGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassGroups>>
>;
export type GetMyClassGroupsQueryError = ErrorType<unknown>;

export function useGetMyClassGroups<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyClassGroupsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassGroups>>,
          TError,
          Awaited<ReturnType<typeof getMyClassGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroups<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassGroups>>,
          TError,
          Awaited<ReturnType<typeof getMyClassGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyClassGroups<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMyClassGroups<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyClassGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyClassGroupsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassGroupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassGroups>>
  > = ({ signal }) => getMyClassGroups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyClassGroupsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassGroups>>
>;
export type GetMyClassGroupsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyClassGroupsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyClassGroupsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroupsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroupsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetMyClassGroupsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroups>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassGroupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyClassGroupsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createClassGroup = (
  createClassGroupReq: BodyType<CreateClassGroupReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassGroupRes>(
    {
      url: `/classrooms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClassGroupReq,
      signal,
    },
    options,
  );
};

export const getCreateClassGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClassGroup>>,
    TError,
    { data: BodyType<CreateClassGroupReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClassGroup>>,
  TError,
  { data: BodyType<CreateClassGroupReq> },
  TContext
> => {
  const mutationKey = ['createClassGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClassGroup>>,
    { data: BodyType<CreateClassGroupReq> }
  > = props => {
    const { data } = props ?? {};

    return createClassGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClassGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClassGroup>>
>;
export type CreateClassGroupMutationBody = BodyType<CreateClassGroupReq>;
export type CreateClassGroupMutationError = ErrorType<unknown>;

export const useCreateClassGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClassGroup>>,
      TError,
      { data: BodyType<CreateClassGroupReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createClassGroup>>,
  TError,
  { data: BodyType<CreateClassGroupReq> },
  TContext
> => {
  const mutationOptions = getCreateClassGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getMaterials = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassMaterialRes>(
    { url: `/classrooms/${classGroupId}/materials`, method: 'GET', signal },
    options,
  );
};

export const getGetMaterialsQueryKey = (classGroupId: string) => {
  return [`/classrooms/${classGroupId}/materials`] as const;
};

export const getGetMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMaterials>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMaterialsQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaterials>>> = ({
    signal,
  }) => getMaterials(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMaterials>>
>;
export type GetMaterialsQueryError = ErrorType<unknown>;

export function useGetMaterials<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMaterials>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaterials>>,
          TError,
          Awaited<ReturnType<typeof getMaterials>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMaterials<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMaterials>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaterials>>,
          TError,
          Awaited<ReturnType<typeof getMaterials>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMaterials<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMaterials>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMaterials<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMaterials>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMaterialsQueryOptions(classGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMaterialsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMaterialsQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaterials>>> = ({
    signal,
  }) => getMaterials(classGroupId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMaterialsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMaterials>>
>;
export type GetMaterialsSuspenseQueryError = ErrorType<unknown>;

export function useGetMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMaterialsSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addMaterial = (
  classGroupId: string,
  createClassMaterialReq: BodyType<CreateClassMaterialReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassMaterialRes>(
    {
      url: `/classrooms/${classGroupId}/materials`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClassMaterialReq,
      signal,
    },
    options,
  );
};

export const getAddMaterialMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMaterial>>,
    TError,
    { classGroupId: string; data: BodyType<CreateClassMaterialReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addMaterial>>,
  TError,
  { classGroupId: string; data: BodyType<CreateClassMaterialReq> },
  TContext
> => {
  const mutationKey = ['addMaterial'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMaterial>>,
    { classGroupId: string; data: BodyType<CreateClassMaterialReq> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return addMaterial(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof addMaterial>>
>;
export type AddMaterialMutationBody = BodyType<CreateClassMaterialReq>;
export type AddMaterialMutationError = ErrorType<unknown>;

export const useAddMaterial = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addMaterial>>,
      TError,
      { classGroupId: string; data: BodyType<CreateClassMaterialReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addMaterial>>,
  TError,
  { classGroupId: string; data: BodyType<CreateClassMaterialReq> },
  TContext
> => {
  const mutationOptions = getAddMaterialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const uploadMaterialFile = (
  classGroupId: string,
  uploadMaterialFileBody: BodyType<UploadMaterialFileBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassMaterialFileUploadRes>(
    {
      url: `/classrooms/${classGroupId}/material-files`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadMaterialFileBody,
      signal,
    },
    options,
  );
};

export const getUploadMaterialFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadMaterialFile>>,
    TError,
    { classGroupId: string; data: BodyType<UploadMaterialFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadMaterialFile>>,
  TError,
  { classGroupId: string; data: BodyType<UploadMaterialFileBody> },
  TContext
> => {
  const mutationKey = ['uploadMaterialFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadMaterialFile>>,
    { classGroupId: string; data: BodyType<UploadMaterialFileBody> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return uploadMaterialFile(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadMaterialFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadMaterialFile>>
>;
export type UploadMaterialFileMutationBody = BodyType<UploadMaterialFileBody>;
export type UploadMaterialFileMutationError = ErrorType<unknown>;

export const useUploadMaterialFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadMaterialFile>>,
      TError,
      { classGroupId: string; data: BodyType<UploadMaterialFileBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadMaterialFile>>,
  TError,
  { classGroupId: string; data: BodyType<UploadMaterialFileBody> },
  TContext
> => {
  const mutationOptions = getUploadMaterialFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getClassLinks = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassLinkRes>(
    { url: `/classrooms/${classGroupId}/links`, method: 'GET', signal },
    options,
  );
};

export const getGetClassLinksQueryKey = (classGroupId: string) => {
  return [`/classrooms/${classGroupId}/links`] as const;
};

export const getGetClassLinksQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassLinks>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassLinksQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassLinks>>> = ({
    signal,
  }) => getClassLinks(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassLinksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassLinks>>
>;
export type GetClassLinksQueryError = ErrorType<unknown>;

export function useGetClassLinks<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassLinks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassLinks>>,
          TError,
          Awaited<ReturnType<typeof getClassLinks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassLinks<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassLinks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassLinks>>,
          TError,
          Awaited<ReturnType<typeof getClassLinks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassLinks<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassLinks>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassLinks<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassLinks>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassLinksQueryOptions(classGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassLinksSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassLinks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassLinksQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassLinks>>> = ({
    signal,
  }) => getClassLinks(classGroupId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassLinksSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassLinks>>
>;
export type GetClassLinksSuspenseQueryError = ErrorType<unknown>;

export function useGetClassLinksSuspense<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassLinks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassLinksSuspense<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassLinks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassLinksSuspense<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassLinks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassLinksSuspense<
  TData = Awaited<ReturnType<typeof getClassLinks>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassLinks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassLinksSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const linkContent = (
  classGroupId: string,
  linkContentReq: BodyType<LinkContentReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassLinkRes>(
    {
      url: `/classrooms/${classGroupId}/links`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: linkContentReq,
      signal,
    },
    options,
  );
};

export const getLinkContentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkContent>>,
    TError,
    { classGroupId: string; data: BodyType<LinkContentReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkContent>>,
  TError,
  { classGroupId: string; data: BodyType<LinkContentReq> },
  TContext
> => {
  const mutationKey = ['linkContent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkContent>>,
    { classGroupId: string; data: BodyType<LinkContentReq> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return linkContent(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkContent>>
>;
export type LinkContentMutationBody = BodyType<LinkContentReq>;
export type LinkContentMutationError = ErrorType<unknown>;

export const useLinkContent = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkContent>>,
      TError,
      { classGroupId: string; data: BodyType<LinkContentReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkContent>>,
  TError,
  { classGroupId: string; data: BodyType<LinkContentReq> },
  TContext
> => {
  const mutationOptions = getLinkContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchLinkableQuizsets = (
  classGroupId: string,
  quizsetSearchReq: BodyType<QuizsetSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SearchResponseListSearchQuizsetRes>(
    {
      url: `/classrooms/${classGroupId}/linkable-quizsets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchLinkableQuizsetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchLinkableQuizsets>>,
    TError,
    { classGroupId: string; data: BodyType<QuizsetSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchLinkableQuizsets>>,
  TError,
  { classGroupId: string; data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationKey = ['searchLinkableQuizsets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchLinkableQuizsets>>,
    { classGroupId: string; data: BodyType<QuizsetSearchReq> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return searchLinkableQuizsets(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchLinkableQuizsetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchLinkableQuizsets>>
>;
export type SearchLinkableQuizsetsMutationBody = BodyType<QuizsetSearchReq>;
export type SearchLinkableQuizsetsMutationError = ErrorType<unknown>;

export const useSearchLinkableQuizsets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchLinkableQuizsets>>,
      TError,
      { classGroupId: string; data: BodyType<QuizsetSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchLinkableQuizsets>>,
  TError,
  { classGroupId: string; data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchLinkableQuizsetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getClassGroupDetail = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassGroupDetailRes>(
    { url: `/classrooms/${classGroupId}`, method: 'GET', signal },
    options,
  );
};

export const getGetClassGroupDetailQueryKey = (classGroupId: string) => {
  return [`/classrooms/${classGroupId}`] as const;
};

export const getGetClassGroupDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassGroupDetailQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassGroupDetail>>
  > = ({ signal }) => getClassGroupDetail(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassGroupDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassGroupDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassGroupDetail>>
>;
export type GetClassGroupDetailQueryError = ErrorType<unknown>;

export function useGetClassGroupDetail<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassGroupDetail>>,
          TError,
          Awaited<ReturnType<typeof getClassGroupDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassGroupDetail<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassGroupDetail>>,
          TError,
          Awaited<ReturnType<typeof getClassGroupDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassGroupDetail<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassGroupDetail<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassGroupDetailQueryOptions(
    classGroupId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassGroupDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassGroupDetailQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassGroupDetail>>
  > = ({ signal }) => getClassGroupDetail(classGroupId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassGroupDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassGroupDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassGroupDetail>>
>;
export type GetClassGroupDetailSuspenseQueryError = ErrorType<unknown>;

export function useGetClassGroupDetailSuspense<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassGroupDetailSuspense<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassGroupDetailSuspense<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassGroupDetailSuspense<
  TData = Awaited<ReturnType<typeof getClassGroupDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassGroupDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassGroupDetailSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteClassGroup = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/classrooms/${classGroupId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteClassGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassGroup>>,
    TError,
    { classGroupId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClassGroup>>,
  TError,
  { classGroupId: string },
  TContext
> => {
  const mutationKey = ['deleteClassGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClassGroup>>,
    { classGroupId: string }
  > = props => {
    const { classGroupId } = props ?? {};

    return deleteClassGroup(classGroupId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClassGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClassGroup>>
>;

export type DeleteClassGroupMutationError = ErrorType<unknown>;

export const useDeleteClassGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClassGroup>>,
      TError,
      { classGroupId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClassGroup>>,
  TError,
  { classGroupId: string },
  TContext
> => {
  const mutationOptions = getDeleteClassGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateClassGroup = (
  classGroupId: string,
  updateClassGroupReq: BodyType<UpdateClassGroupReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyClassGroupRes>(
    {
      url: `/classrooms/${classGroupId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateClassGroupReq,
    },
    options,
  );
};

export const getUpdateClassGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassGroup>>,
    TError,
    { classGroupId: string; data: BodyType<UpdateClassGroupReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClassGroup>>,
  TError,
  { classGroupId: string; data: BodyType<UpdateClassGroupReq> },
  TContext
> => {
  const mutationKey = ['updateClassGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClassGroup>>,
    { classGroupId: string; data: BodyType<UpdateClassGroupReq> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return updateClassGroup(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClassGroup>>
>;
export type UpdateClassGroupMutationBody = BodyType<UpdateClassGroupReq>;
export type UpdateClassGroupMutationError = ErrorType<unknown>;

export const useUpdateClassGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClassGroup>>,
      TError,
      { classGroupId: string; data: BodyType<UpdateClassGroupReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateClassGroup>>,
  TError,
  { classGroupId: string; data: BodyType<UpdateClassGroupReq> },
  TContext
> => {
  const mutationOptions = getUpdateClassGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getClassMembers = (
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyMemberListRes>(
    {
      url: `/classrooms/${classGroupId}/members`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassMembersQueryKey = (
  classGroupId: string,
  params?: GetClassMembersParams,
) => {
  return [
    `/classrooms/${classGroupId}/members`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassMembersQueryKey(classGroupId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassMembers>>> = ({
    signal,
  }) => getClassMembers(classGroupId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassMembers>>
>;
export type GetClassMembersQueryError = ErrorType<unknown>;

export function useGetClassMembers<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params: undefined | GetClassMembersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassMembers>>,
          TError,
          Awaited<ReturnType<typeof getClassMembers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMembers<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassMembers>>,
          TError,
          Awaited<ReturnType<typeof getClassMembers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassMembers<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassMembers<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassMembersQueryOptions(
    classGroupId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassMembersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassMembersQueryKey(classGroupId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassMembers>>> = ({
    signal,
  }) => getClassMembers(classGroupId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassMembersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassMembers>>
>;
export type GetClassMembersSuspenseQueryError = ErrorType<unknown>;

export function useGetClassMembersSuspense<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params: undefined | GetClassMembersParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMembersSuspense<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMembersSuspense<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassMembersSuspense<
  TData = Awaited<ReturnType<typeof getClassMembers>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  params?: GetClassMembersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassMembersSuspenseQueryOptions(
    classGroupId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateMemberNames = (
  classGroupId: string,
  updateMemberNamesReq: BodyType<UpdateMemberNamesReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyUpdateMemberNamesRes>(
    {
      url: `/classrooms/${classGroupId}/members`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMemberNamesReq,
    },
    options,
  );
};

export const getUpdateMemberNamesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberNames>>,
    TError,
    { classGroupId: string; data: BodyType<UpdateMemberNamesReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemberNames>>,
  TError,
  { classGroupId: string; data: BodyType<UpdateMemberNamesReq> },
  TContext
> => {
  const mutationKey = ['updateMemberNames'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemberNames>>,
    { classGroupId: string; data: BodyType<UpdateMemberNamesReq> }
  > = props => {
    const { classGroupId, data } = props ?? {};

    return updateMemberNames(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberNamesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemberNames>>
>;
export type UpdateMemberNamesMutationBody = BodyType<UpdateMemberNamesReq>;
export type UpdateMemberNamesMutationError = ErrorType<unknown>;

export const useUpdateMemberNames = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMemberNames>>,
      TError,
      { classGroupId: string; data: BodyType<UpdateMemberNamesReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberNames>>,
  TError,
  { classGroupId: string; data: BodyType<UpdateMemberNamesReq> },
  TContext
> => {
  const mutationOptions = getUpdateMemberNamesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const removeMember = (
  classGroupId: string,
  userId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/classrooms/${classGroupId}/members/${userId}`, method: 'DELETE' },
    options,
  );
};

export const getRemoveMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMember>>,
    TError,
    { classGroupId: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMember>>,
  TError,
  { classGroupId: string; userId: string },
  TContext
> => {
  const mutationKey = ['removeMember'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMember>>,
    { classGroupId: string; userId: string }
  > = props => {
    const { classGroupId, userId } = props ?? {};

    return removeMember(classGroupId, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeMember>>
>;

export type RemoveMemberMutationError = ErrorType<unknown>;

export const useRemoveMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeMember>>,
      TError,
      { classGroupId: string; userId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMember>>,
  TError,
  { classGroupId: string; userId: string },
  TContext
> => {
  const mutationOptions = getRemoveMemberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 레거시 userId 기반 단건 수정 API. 신규 호출은 멤버 일괄 수정 API를 사용합니다.
 * @deprecated
 */
export const updateMember = (
  classGroupId: string,
  userId: string,
  updateMemberReq: BodyType<UpdateMemberReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyClassMemberRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMemberReq,
    },
    options,
  );
};

export const getUpdateMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMember>>,
    TError,
    { classGroupId: string; userId: string; data: BodyType<UpdateMemberReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMember>>,
  TError,
  { classGroupId: string; userId: string; data: BodyType<UpdateMemberReq> },
  TContext
> => {
  const mutationKey = ['updateMember'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMember>>,
    { classGroupId: string; userId: string; data: BodyType<UpdateMemberReq> }
  > = props => {
    const { classGroupId, userId, data } = props ?? {};

    return updateMember(classGroupId, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMember>>
>;
export type UpdateMemberMutationBody = BodyType<UpdateMemberReq>;
export type UpdateMemberMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useUpdateMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMember>>,
      TError,
      { classGroupId: string; userId: string; data: BodyType<UpdateMemberReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMember>>,
  TError,
  { classGroupId: string; userId: string; data: BodyType<UpdateMemberReq> },
  TContext
> => {
  const mutationOptions = getUpdateMemberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteMaterial = (
  classGroupId: string,
  classMaterialId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/classrooms/${classGroupId}/materials/${classMaterialId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteMaterialMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMaterial>>,
    TError,
    { classGroupId: string; classMaterialId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMaterial>>,
  TError,
  { classGroupId: string; classMaterialId: string },
  TContext
> => {
  const mutationKey = ['deleteMaterial'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMaterial>>,
    { classGroupId: string; classMaterialId: string }
  > = props => {
    const { classGroupId, classMaterialId } = props ?? {};

    return deleteMaterial(classGroupId, classMaterialId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMaterial>>
>;

export type DeleteMaterialMutationError = ErrorType<unknown>;

export const useDeleteMaterial = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMaterial>>,
      TError,
      { classGroupId: string; classMaterialId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMaterial>>,
  TError,
  { classGroupId: string; classMaterialId: string },
  TContext
> => {
  const mutationOptions = getDeleteMaterialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateMaterial = (
  classGroupId: string,
  classMaterialId: string,
  updateClassMaterialReq: BodyType<UpdateClassMaterialReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyClassMaterialRes>(
    {
      url: `/classrooms/${classGroupId}/materials/${classMaterialId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateClassMaterialReq,
    },
    options,
  );
};

export const getUpdateMaterialMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMaterial>>,
    TError,
    {
      classGroupId: string;
      classMaterialId: string;
      data: BodyType<UpdateClassMaterialReq>;
    },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMaterial>>,
  TError,
  {
    classGroupId: string;
    classMaterialId: string;
    data: BodyType<UpdateClassMaterialReq>;
  },
  TContext
> => {
  const mutationKey = ['updateMaterial'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMaterial>>,
    {
      classGroupId: string;
      classMaterialId: string;
      data: BodyType<UpdateClassMaterialReq>;
    }
  > = props => {
    const { classGroupId, classMaterialId, data } = props ?? {};

    return updateMaterial(classGroupId, classMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMaterial>>
>;
export type UpdateMaterialMutationBody = BodyType<UpdateClassMaterialReq>;
export type UpdateMaterialMutationError = ErrorType<unknown>;

export const useUpdateMaterial = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMaterial>>,
      TError,
      {
        classGroupId: string;
        classMaterialId: string;
        data: BodyType<UpdateClassMaterialReq>;
      },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMaterial>>,
  TError,
  {
    classGroupId: string;
    classMaterialId: string;
    data: BodyType<UpdateClassMaterialReq>;
  },
  TContext
> => {
  const mutationOptions = getUpdateMaterialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteClassLink = (
  classGroupId: string,
  classLinkId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/classrooms/${classGroupId}/links/${classLinkId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteClassLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassLink>>,
    TError,
    { classGroupId: string; classLinkId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClassLink>>,
  TError,
  { classGroupId: string; classLinkId: string },
  TContext
> => {
  const mutationKey = ['deleteClassLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClassLink>>,
    { classGroupId: string; classLinkId: string }
  > = props => {
    const { classGroupId, classLinkId } = props ?? {};

    return deleteClassLink(classGroupId, classLinkId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClassLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClassLink>>
>;

export type DeleteClassLinkMutationError = ErrorType<unknown>;

export const useDeleteClassLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClassLink>>,
      TError,
      { classGroupId: string; classLinkId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClassLink>>,
  TError,
  { classGroupId: string; classLinkId: string },
  TContext
> => {
  const mutationOptions = getDeleteClassLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateClassLinkVisibility = (
  classGroupId: string,
  classLinkId: string,
  updateClassLinkReq: BodyType<UpdateClassLinkReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyClassLinkRes>(
    {
      url: `/classrooms/${classGroupId}/links/${classLinkId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateClassLinkReq,
    },
    options,
  );
};

export const getUpdateClassLinkVisibilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassLinkVisibility>>,
    TError,
    {
      classGroupId: string;
      classLinkId: string;
      data: BodyType<UpdateClassLinkReq>;
    },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClassLinkVisibility>>,
  TError,
  {
    classGroupId: string;
    classLinkId: string;
    data: BodyType<UpdateClassLinkReq>;
  },
  TContext
> => {
  const mutationKey = ['updateClassLinkVisibility'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClassLinkVisibility>>,
    {
      classGroupId: string;
      classLinkId: string;
      data: BodyType<UpdateClassLinkReq>;
    }
  > = props => {
    const { classGroupId, classLinkId, data } = props ?? {};

    return updateClassLinkVisibility(
      classGroupId,
      classLinkId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassLinkVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClassLinkVisibility>>
>;
export type UpdateClassLinkVisibilityMutationBody =
  BodyType<UpdateClassLinkReq>;
export type UpdateClassLinkVisibilityMutationError = ErrorType<unknown>;

export const useUpdateClassLinkVisibility = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClassLinkVisibility>>,
      TError,
      {
        classGroupId: string;
        classLinkId: string;
        data: BodyType<UpdateClassLinkReq>;
      },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateClassLinkVisibility>>,
  TError,
  {
    classGroupId: string;
    classLinkId: string;
    data: BodyType<UpdateClassLinkReq>;
  },
  TContext
> => {
  const mutationOptions = getUpdateClassLinkVisibilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getClassroomRole = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassroomRoleRes>(
    { url: `/classrooms/${classGroupId}/role`, method: 'GET', signal },
    options,
  );
};

export const getGetClassroomRoleQueryKey = (classGroupId: string) => {
  return [`/classrooms/${classGroupId}/role`] as const;
};

export const getGetClassroomRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomRoleQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomRole>>
  > = ({ signal }) => getClassroomRole(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomRoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomRole>>
>;
export type GetClassroomRoleQueryError = ErrorType<unknown>;

export function useGetClassroomRole<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomRole>>,
          TError,
          Awaited<ReturnType<typeof getClassroomRole>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomRole<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomRole>>,
          TError,
          Awaited<ReturnType<typeof getClassroomRole>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomRole<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomRole<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomRoleQueryOptions(classGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassroomRoleSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomRoleQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomRole>>
  > = ({ signal }) => getClassroomRole(classGroupId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassroomRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomRoleSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomRole>>
>;
export type GetClassroomRoleSuspenseQueryError = ErrorType<unknown>;

export function useGetClassroomRoleSuspense<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomRoleSuspense<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomRoleSuspense<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassroomRoleSuspense<
  TData = Awaited<ReturnType<typeof getClassroomRole>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomRole>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassroomRoleSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomMemberStats = (
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassroomMemberStatsRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/stats`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassroomMemberStatsQueryKey = (
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/stats`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomMemberStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomMemberStatsQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomMemberStats>>
  > = ({ signal }) =>
    getClassroomMemberStats(
      classGroupId,
      userId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(classGroupId && userId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomMemberStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomMemberStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomMemberStats>>
>;
export type GetClassroomMemberStatsQueryError = ErrorType<unknown>;

export function useGetClassroomMemberStats<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassroomMemberStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomMemberStats>>,
          TError,
          Awaited<ReturnType<typeof getClassroomMemberStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomMemberStats<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomMemberStats>>,
          TError,
          Awaited<ReturnType<typeof getClassroomMemberStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomMemberStats<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomMemberStats<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomMemberStatsQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassroomMemberStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomMemberStatsQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomMemberStats>>
  > = ({ signal }) =>
    getClassroomMemberStats(
      classGroupId,
      userId,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassroomMemberStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomMemberStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomMemberStats>>
>;
export type GetClassroomMemberStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetClassroomMemberStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassroomMemberStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomMemberStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomMemberStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassroomMemberStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassroomMemberStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassroomMemberStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassroomMemberStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassroomMemberStatsSuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassMemberQuizsetStats = (
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsPlayerDetailResponse>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/quizset-stats`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassMemberQuizsetStatsQueryKey = (
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/quizset-stats`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassMemberQuizsetStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassMemberQuizsetStatsQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
  > = ({ signal }) =>
    getClassMemberQuizsetStats(
      classGroupId,
      userId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(classGroupId && userId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassMemberQuizsetStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
>;
export type GetClassMemberQuizsetStatsQueryError = ErrorType<unknown>;

export function useGetClassMemberQuizsetStats<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
          TError,
          Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMemberQuizsetStats<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
          TError,
          Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassMemberQuizsetStats<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassMemberQuizsetStats<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassMemberQuizsetStatsQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassMemberQuizsetStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassMemberQuizsetStatsQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
  > = ({ signal }) =>
    getClassMemberQuizsetStats(
      classGroupId,
      userId,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassMemberQuizsetStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassMemberQuizsetStats>>
>;
export type GetClassMemberQuizsetStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetClassMemberQuizsetStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMemberQuizsetStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassMemberQuizsetStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassMemberQuizsetStatsSuspense<
  TData = Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: GetClassMemberQuizsetStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassMemberQuizsetStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassMemberQuizsetStatsSuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOwnedClassrooms = (
  params?: GetOwnedClassroomsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassroomDashboardRes>(
    { url: `/classrooms/owned`, method: 'GET', params, signal },
    options,
  );
};

export const getGetOwnedClassroomsQueryKey = (
  params?: GetOwnedClassroomsParams,
) => {
  return [`/classrooms/owned`, ...(params ? [params] : [])] as const;
};

export const getGetOwnedClassroomsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOwnedClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOwnedClassrooms>>
  > = ({ signal }) => getOwnedClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOwnedClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOwnedClassroomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOwnedClassrooms>>
>;
export type GetOwnedClassroomsQueryError = ErrorType<unknown>;

export function useGetOwnedClassrooms<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetOwnedClassroomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getOwnedClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOwnedClassrooms<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getOwnedClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOwnedClassrooms<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOwnedClassrooms<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOwnedClassroomsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOwnedClassroomsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOwnedClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOwnedClassrooms>>
  > = ({ signal }) => getOwnedClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOwnedClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOwnedClassroomsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOwnedClassrooms>>
>;
export type GetOwnedClassroomsSuspenseQueryError = ErrorType<unknown>;

export function useGetOwnedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetOwnedClassroomsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOwnedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOwnedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetOwnedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getOwnedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOwnedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOwnedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetOwnedClassroomsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMyClassGroupsLinkedToContent = (
  params: GetMyClassGroupsLinkedToContentParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassGroupRes>(
    { url: `/classrooms/linked`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyClassGroupsLinkedToContentQueryKey = (
  params: GetMyClassGroupsLinkedToContentParams,
) => {
  return [`/classrooms/linked`, ...(params ? [params] : [])] as const;
};

export const getGetMyClassGroupsLinkedToContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMyClassGroupsLinkedToContentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
  > = ({ signal }) =>
    getMyClassGroupsLinkedToContent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyClassGroupsLinkedToContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
>;
export type GetMyClassGroupsLinkedToContentQueryError = ErrorType<unknown>;

export function useGetMyClassGroupsLinkedToContent<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
          TError,
          Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroupsLinkedToContent<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
          TError,
          Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyClassGroupsLinkedToContent<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMyClassGroupsLinkedToContent<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyClassGroupsLinkedToContentQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyClassGroupsLinkedToContentSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMyClassGroupsLinkedToContentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
  > = ({ signal }) =>
    getMyClassGroupsLinkedToContent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyClassGroupsLinkedToContentSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>
>;
export type GetMyClassGroupsLinkedToContentSuspenseQueryError =
  ErrorType<unknown>;

export function useGetMyClassGroupsLinkedToContentSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroupsLinkedToContentSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyClassGroupsLinkedToContentSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetMyClassGroupsLinkedToContentSuspense<
  TData = Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
  TError = ErrorType<unknown>,
>(
  params: GetMyClassGroupsLinkedToContentParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassGroupsLinkedToContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyClassGroupsLinkedToContentSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getJoinedClassrooms = (
  params?: GetJoinedClassroomsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassroomDashboardRes>(
    { url: `/classrooms/joined`, method: 'GET', params, signal },
    options,
  );
};

export const getGetJoinedClassroomsQueryKey = (
  params?: GetJoinedClassroomsParams,
) => {
  return [`/classrooms/joined`, ...(params ? [params] : [])] as const;
};

export const getGetJoinedClassroomsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetJoinedClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJoinedClassrooms>>
  > = ({ signal }) => getJoinedClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJoinedClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJoinedClassroomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJoinedClassrooms>>
>;
export type GetJoinedClassroomsQueryError = ErrorType<unknown>;

export function useGetJoinedClassrooms<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetJoinedClassroomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJoinedClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getJoinedClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJoinedClassrooms<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJoinedClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getJoinedClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJoinedClassrooms<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetJoinedClassrooms<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetJoinedClassroomsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetJoinedClassroomsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetJoinedClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJoinedClassrooms>>
  > = ({ signal }) => getJoinedClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getJoinedClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJoinedClassroomsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJoinedClassrooms>>
>;
export type GetJoinedClassroomsSuspenseQueryError = ErrorType<unknown>;

export function useGetJoinedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetJoinedClassroomsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJoinedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJoinedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetJoinedClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getJoinedClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJoinedClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getJoinedClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetJoinedClassroomsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const getAllClassrooms = (
  params?: GetAllClassroomsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassroomDashboardRes>(
    { url: `/classrooms/all`, method: 'GET', params, signal },
    options,
  );
};

export const getGetAllClassroomsQueryKey = (
  params?: GetAllClassroomsParams,
) => {
  return [`/classrooms/all`, ...(params ? [params] : [])] as const;
};

export const getGetAllClassroomsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllClassrooms>>
  > = ({ signal }) => getAllClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllClassroomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllClassrooms>>
>;
export type GetAllClassroomsQueryError = ErrorType<unknown>;

export function useGetAllClassrooms<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetAllClassroomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getAllClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllClassrooms<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getAllClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllClassrooms<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useGetAllClassrooms<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllClassroomsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAllClassroomsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllClassroomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllClassrooms>>
  > = ({ signal }) => getAllClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAllClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllClassroomsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllClassrooms>>
>;
export type GetAllClassroomsSuspenseQueryError = ErrorType<unknown>;

export function useGetAllClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetAllClassroomsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @deprecated
 */

export function useGetAllClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getAllClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAllClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetAllClassroomsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
